import axios from "axios";

export const API = axios.create({
  baseURL: `${import.meta.env.APP_API_ENDPOINT}/api`,
  headers: { "Content-Type": "application/json; charset=utf-8" },
  withCredentials: true,
});

export const AuthAPI = axios.create({
  baseURL: `${import.meta.env.APP_API_ENDPOINT}/_allauth`,
  headers: { "Content-Type": "application/json; charset=utf-8" },
  withCredentials: true,
});

export function equalAsSet<T>(foo: T[] | undefined, bar: T[] | undefined) {
  const fooSet = new Set(foo ?? []);
  const barSet = new Set(bar ?? []);

  return fooSet.size === barSet.size && [...fooSet].every((x) => barSet.has(x));
}

export const capitalize = ([first, ...rest]: string, lowerRest = true) =>
  first.toUpperCase() +
  (lowerRest ? rest.join("").toLowerCase() : rest.join(""));
